import { render } from "./tutorHome.vue?vue&type=template&id=4f9af5ec&scoped=true"
import script from "./tutorHome.vue?vue&type=script&lang=js"
export * from "./tutorHome.vue?vue&type=script&lang=js"

import "./tutorHome.vue?vue&type=style&index=0&id=4f9af5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9af5ec"]])

export default __exports__